<template>
  <div id="app" @click="handleTime()" v-if="isRouterAlive">
    <router-view />
  </div>
</template>

<script>
  import {
    messageshow,
    API
  } from '../static/API/API.js'
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        timmer: null,
        lastTime: null,
        isRouterAlive: true
      }
    },
    methods: {
      handleTime() {
        const curTime = new Date();
        console.log(curTime - this.lastTime > 1000 * 60 * 30)
        this.read()
        // if (curTime - this.lastTime > 1000 * 60 * 1) {
        //   //退出
        //   if (this.$route.path == '/') {
        //     return
        //   }
        //   alert('登录超时，将返回登录页');
        //   // setTimeout(() => {
        //   this.$router.push({
        //     path: '/'
        //   })
        //   location.reload()
        //   // }, 2000)

        // } else {
        //   this.lastTime = curTime;
        // }
      },
      read() {
        let params = new URLSearchParams()
        params.append('ope_type', '未读数量')
        params.append('recv_user_name', sessionStorage.getItem('name'))
        params.append('recv_user_id', sessionStorage.getItem('user_id'))
        params.append('recv_user_type', '后台')
        this.$axios.get(messageshow, {
          params
        }).then(res => {
          this.NUM = res.data
        })
      },
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function() {
          this.isRouterAlive = true
        })
      }
    },
    created() {
      console.log(API)
      console.log(  process.env.NODE_ENV)

      // this.lastTime = new Date();

      // window.addEventListener('resize', () => {
      //   this.handleTime();
      // })

      // window.addEventListener('scroll', () => {
      //   if (this.timmer) {
      //     clearTimeout(this.timmer);
      //   }

      //   this.timmer = setTimeout(() => {
      //     this.handleTime();
      //   }, 3000)
      // }, true)
    }
  }
</script>

<style>
  @import "./css/public.css";
  @import "./css/yw.css";
  /* @import './css/index.css'; */
  @import './css/login.css';

  html,
  body,
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    height: 100% !important;
  }
  .el-table__body-wrapper tbody tr td,.el-table__cell{  
   text-align: center !important;  
}

  .el-pagination.is-background .el-pager li{
    min-width: 23px ;
    margin: 0 3px ;
  }
  
  .el-dialog{
    position: absolute;
    left: 300px;
    top: 50px;
  }
  .el-button--primary{
    background-color: #1b213f;
    border-color: #1b213f;
  }
  .el-button--primary:focus, .el-button--primary:hover{
    background-color: #333c6b;
    border-color: #333c6b;
  }
  .el-message-box{
  width: 560px !important;
}
  /* ::v-deep .el-dialog{
       display: flex;
       flex-direction: column;
       margin:0 !important;
       position:absolute;
       top:50%;
       left:50%;
       transform:translate(-50%,-50%);
       max-height:calc(100% - 30px);
       max-width:calc(100% - 30px);
   }
  ::v-deep  .el-dialog .el-dialog__body{
       flex:1;
       overflow: auto;
   } */
  /*媒体查询：注意and后面空格的添加*/
  /*iphone: w < 768px*/
  @media screen and (max-width: 768px) {
    body {
      width: 100%;
      /* background-color: green; */
    }

    .el-dialog__wrapper .el-dialog {
      width: 95% !important;
    }

    .el-dialog__wrapper .el-dialog .el-dialog__body {
      overflow: auto
    }

    .el-message {
      min-width: 300px !important;
    }

    /* 轮播 */
    .carousel {
      width: 60%;
      height: 18.125rem;
      margin-left: 20%;
    }

    .el-carousel__container {
      position: relative;
      height: 19.5rem !important;
    }

    .CompanyTitle {
      display: none;
    }

    /* pc首页底部样式 */
    .footerbot {
      line-height: 33px;
      color: #000000;
    }
    /* 商品排版 */
    .commodity div {
      padding-left: 10px;
      padding-right: 30px;
    }
  }

  /*pad: w >= 768  && w< 992*/
  @media screen and (max-width: 992px) and (min-width: 768px) {
    body {
      width: 750px;
      /* background-color: blue; */
    }

    .el-col-lg-10 {
      width: 100%;
    }

    .el-col-md-11 {
      width: 100%;
    }

    .el-dialog__wrapper .el-dialog {
      width: 95% !important;
    }

    .el-dialog__wrapper .el-dialog .el-dialog__body {
      overflow: auto
    }

    .el-message {
      min-width: 300px !important;
    }

    .information {
      box-sizing: border-box;
      padding: 110px 0;
      width: 100%;
      margin: auto;
    }

    /* 轮播 */
    .carousel {
      width: 60%;
      height: 18.125rem;
      margin-left: 20%;
    }

    .el-carousel__container {
      position: relative;
      height: 19.5rem !important;
    }

    /* pc首页标题显示 */
    .CompanyTitle {
      display: none;
    }

    /* pc首页底部样式 */
    .footerbot {
      line-height: 33px;
      color: #000000;
    }
    /* 商品排版 */
    .commodity div {
      width: 351px;
      display: table-cell;
      vertical-align: top;
      padding-left: 10px;
      padding-right: 30px;
    }
  }

  /*中等屏幕   w >= 992  && w<1200*/
  @media screen and (max-width: 1200px) and (min-width: 992px) {
    body {
      width: 100%;
      /* background-color: pink; */
    }

    .el-col-lg-10 {
      width: 100%;
      /* margin-left: 20%; */
    }

    .information {
      box-sizing: border-box;
      padding: 110px 0;
      width: 85%;
      margin: auto;
    }

    /* 轮播 */
    .carousel {
      width: 60%;
      height: 28.125rem;
      margin-left: 20%;
    }

    .el-carousel__container {
      position: relative;
      height: 29.5rem !important;
    }

    .CompanyTitle {
      height: 155px;
      padding-top: 30px;
      display: flex;
      align-items: center;
      width: 100%;
      margin: auto;
    }

    .footerbot {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      line-height: 33px;
      color: #000000;
    }
    /* 商品排版 */
    .commodity div {
      width: 351px;
      display: table-cell;
      vertical-align: top;
      padding-left: 10px;
      padding-right: 30px;
    }
  }

  element.style {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 10px;
  }

  @media only screen and (min-width: 1200px) {
    .el-col-lg-10 {
      width: 100%;
    }

    .el-col-xl-20 {
      width: 63.33333%;
      margin-left: 20%;
    }

    .information {
      box-sizing: border-box;
      padding: 110px 0;
      width: 80%;
      margin: auto;
    }

    /* 轮播 */
    .carousel {
      width: 60%;
      height: 28.125rem;
      margin-left: 20%;
    }

    .el-carousel__container {
      position: relative;
      height: 29.5rem !important;
    }

    .CompanyTitle {
      height: 155px;
      padding-top: 30px;
      display: flex;
      align-items: center;
      width: 80%;
      margin: auto;
    }

    .footerbot {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      line-height: 33px;
      color: #000000;
    }
    /* 商品排版 */
    .commodity div {
      width: 351px;
      display: table-cell;
      vertical-align: top;
      padding-left: 10px;
      padding-right: 30px;
    }
  }

  @media screen and (max-width: 2560px) and (min-width: 1440px) {
    .el-col-lg-10 {
      width: 100%;
    }

    .el-col-xl-20 {
      width: 63.33333%;
      margin-left: 20%;
    }

    .information {
      box-sizing: border-box;
      padding: 110px 0;
      width: 80%;
      margin: auto;
    }

    /* 轮播 */
    .carousel {
      width: 60%;
      height: 28.125rem;
      margin-left: 20%;
    }

    .el-carousel__container {
      position: relative;
      height: 29.5rem !important;
    }

    .CompanyTitle {
      height: 155px;
      padding-top: 30px;
      display: flex;
      align-items: center;
      width: 81%;
      padding-left: 15%;
    }

    .footerbot {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      line-height: 33px;
      color: #000000;
    }
    /* 商品排版 */
    .commodity div {
      width: 351px;
      display: table-cell;
      vertical-align: top;
      padding-left: 10px;
      padding-right: 30px;
    }
     .el-table .cell {
 color: black !important;
}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue